import { Button } from "antd";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Headers from "../../../redux/Actions/Headers/Header";
import { useDispatch } from "react-redux";
import {LockOutlined} from '@ant-design/icons';
import TypographyComponent from "../../../Components/Typography/Typography";
import Messages from "../../../Components/Message/Messages";

const UnAuthorized = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const Logout = ()=>{
        localStorage.removeItem("userData");
    localStorage.removeItem("auth_token");
    navigate("/login")
    }
     useEffect(() => {
        dispatch(
          Headers.setHeader({
            title: "Access Denied",
            actions: [],
          })
        );
        return () => dispatch(Headers.resetHeader());
      }, []);
  return (
    <div >
       <Messages  status="403"
          title="Access Denied"
          subTitle="Sorry, you are not authorized to access this page."
         className="custom-404-result"
          icon={<LockOutlined  />}
          extra={[
            <div key="message" style={{ marginBottom: 24 }}>
              <TypographyComponent level={5}>
              You are not authorized to access hub. Please contact your administrator.
              </TypographyComponent>
            </div> ,
            <Button onClick={Logout} type="primary" key={"login"} size="large">
             Try Again
            </Button>]}/>  
    </div>
  );
};

export default UnAuthorized;